import { CourseWeek } from '../../../../modules/Courses/models/Course.model';
import { Button } from '../../../components/atoms/Button';
import { Icon } from '../../../components/atoms/Icon';
import { Typography } from '../../../components/molecules/Typography';

interface IDropdownButton {
  week: CourseWeek | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  disabled?: boolean;
}

export default function DropdownButton({
  week,
  isOpen,
  setIsOpen,
  disabled = false,
}: IDropdownButton) {
  return (
    <div className='flex w-fit flex-row items-center'>
      <Button
        allowReadOnly
        size='regular'
        variant='text'
        className='px-0 pl-4 text-black'
        onClick={() => setIsOpen(!isOpen)}
        data-tooltip-id={`week-select`}
        disabled={disabled}
      >
        <Typography type='title' className='xs:text-h4 md:text-h2'>
          {week ? week.title : 'Selecione'}
        </Typography>
        {isOpen ? (
          <Icon
            Icon='expand_less'
            type='material'
            className='text-mono-color-black'
          />
        ) : (
          <Icon
            Icon='expand_more'
            type='material'
            className='text-mono-color-black'
          />
        )}
      </Button>
    </div>
  );
}
